import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-business-verification-errors',
  templateUrl: './business-verification-api-errors.component.html',
  styleUrls: ['./business-verification-api-errors.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BusinessVerificationApiErrorsComponent {
  title: string = 'Business Verifications Errors';
}
